// src/components/application/FinancialSummary.tsx
import React from "react";
import { ApplicationBankDetails } from "../../types";

export const FinancialSummary: React.FC<ApplicationBankDetails> = ({
  logoUrl,
  accountNumber,
}) => (
  <div className="flex items-center">
    {logoUrl && <img src={logoUrl} alt="" height={24} className="mr-2" />}
    <span>{accountNumber}</span>
  </div>
);
